import React, { useState } from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Checkbox from "@material-ui/core/Checkbox";
import Container from "@material-ui/core/Container";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/icons components
import Email from "@material-ui/icons/Email";
import Lock from "@material-ui/icons/Lock";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

// core components
import AuthHeader from "components/Headers/AuthHeader.js";
import componentStyles from "assets/theme/views/auth/login.js";
import componentStylesButtons from "assets/theme/components/button.js";
import { Typography } from "@material-ui/core";

//image import


const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);

function Login() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const history = useHistory();
  const theme = useTheme();

  //use states
  const [form, setform] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [invalidLogin, setInvalidLogin] = useState(0);//use to show invalid credentials txt

  //text fields changes
  const handleChange = (e) => {
    if(invalidLogin === 1){
      setInvalidLogin(0)
    }
    setform((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
   
  //main login button click fucntion
  const LoginClick = () => {
    const fetchLogin = async () => {
      try {
        const res = await fetch("https://server.thelanofficial.com/login", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: form.username,
            password: form.password,
          }),
        });

        if (!res.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await res.json();

        if (data.valid === false) {
          setInvalidLogin(1);
        } else if (data.valid === true) {

          if(data.privilege === "teacher"){
          localStorage.setItem("token", data.token);
          history.push("/admin/Assigned-Courses")
          }
          else if(data.privilege === "admin" || data.privilege === "super admin"){
            localStorage.setItem("token", data.token);
            history.push("/admin/Createuser")
            }else if(data.privilege === "student"){
              localStorage.setItem("token", data.token);
              history.push("/admin/Enrolled-Courses")
              }

        }
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
      }
    };

    fetchLogin();
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <>
      <AuthHeader
        title="Welcome to THE LAN!"
        description="Upscaling your career life"
      />
      {/* Page content */}
      <Container
        component={Box}
        maxWidth="xl"
        marginTop="-8rem"
        paddingBottom="3rem"
        position="relative"
        zIndex="101"
      >
        <Box component={Grid} container justifyContent="center">
          <Grid item xs={12} lg={5} md={7}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title={
                  <Box
                    fontSize="200%"
                    fontWeight="800"
                    component="large"
                    color={theme.palette.gray[600]}
                  >
                    LOGIN
                  </Box>
                }
                titleTypographyProps={{
                  component: Box,
                  textAlign: "center",
                  marginBottom: "1rem!important",
                  marginTop: ".5rem!important",
                  fontSize: "1rem!important",
                }}
              ></CardHeader>
              <CardContent classes={{ root: classes.cardContent }}>
                <Box
                  color={theme.palette.gray[600]}
                  textAlign="center"
                  marginBottom="1rem"
                  marginTop=".5rem"
                  fontSize="1rem"
                >
                  <Box fontSize="80%" fontWeight="400" component="small">
                    sign in with credentials
                  </Box>
                </Box>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1rem!important"
                >
                  <FilledInput
                    onChange={handleChange}
                    autoComplete="off"
                    type="email"
                    name="username"
                    placeholder="Username"
                    startAdornment={
                      <InputAdornment position="start">
                        <Email />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl
                  variant="filled"
                  component={Box}
                  width="100%"
                  marginBottom="1.5rem!important"
                >
                  <FilledInput
                    onChange={handleChange}
                    autoComplete="off"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    startAdornment={
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleTogglePasswordVisibility}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />

                </FormControl>

                {invalidLogin === 1 && (
                  <Typography style={{ color: "red", fontSize: "10px" }}>
                    Invalid credentials
                  </Typography>
                )}


                <FormControlLabel
                  value="end"
                  control={<Checkbox color="primary" />}
                  label="Remember me"
                  labelPlacement="end"
                  classes={{
                    root: classes.formControlLabelRoot,
                    label: classes.formControlLabelLabel,
                  }}
                />
                <Box
                  textAlign="center"
                  marginTop="1.5rem"
                  marginBottom="1.5rem"
                >
                  <Button
                    variant="contained"
                  
                    onClick={LoginClick}
                    classes={{ root: classes.buttonContainedInfo }}
                  >
                    Sign in
                  </Button>
                </Box>
              </CardContent>
            </Card>
            <Grid container component={Box} marginTop="1rem">
              <Grid item xs={6} component={Box} textAlign="left"></Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default Login;
